import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnChanges, HostBinding, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'enl-counter2',
  template: `  <div class="double-element">
  <p>{{_counter}}</p>

  <button (click)="increase()">Add ONE (secondo)</button>
  <button (click)="descrease()">Minus ONE (secondo)</button>
</div>`,
  styles: [`.double-element{border:1px solid #aaa;padding:10px;text-align:center;background-color:#ff0}`]
  //encapsulation: ViewEncapsulation.Native
})



export class Counter2Component implements OnInit, OnChanges { // , AfterViewChecked

 public _counter:number = 0;

  @Input()
  set counter(counter: number) {
    this._counter = counter;
  }
  get counter(): number {
    return this._counter;
  }
  
  @Output() counterEmitter = new EventEmitter<number>();

  constructor(private _changeDetectorRef: ChangeDetectorRef) { 
    console.log('constructor');
  }


// ngAfterViewChecked() {
    /* This way the detector will run after every change */
 //   this._changeDetectorRef.detectChanges();
 // }


  ngOnInit() {
    console.log('ngOnInit');
  }

  ngOnChanges() {
    console.log('ngOnChanges');
  }
  increase() {
    this._counter++;
       /* This way you run detector only on this function call */
    this._changeDetectorRef.detectChanges();

    console.log("increase. counter= " + this._counter);
     this.counterEmitter.emit(this._counter);
  }

  descrease() {
    this._counter--;
    console.log("descrease. counter= " + this._counter);
    /* This way you run detector only on this function call */
    this._changeDetectorRef.detectChanges();
     this.counterEmitter.emit(this._counter);
  }
}